import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';

export interface UpdateExternalConfigPayload {
  name?: string;
  status?: 'CURRENT' | 'OBSOLETE';
  includeInMasterList?: boolean;
  externalRevision?: string;
  hasValidity?: boolean;
  validityDate?: string | null;
  format?: string;
  editedByUserId?: number;
  editedByPositionId?: number;
  configuredAt?: string;
  physicalLocations?: { locationId: number; quantity: number }[];
  notificationDates?: string[];
  notificationMemberIds?: number[];
}

class UpdateExternalConfigApi {
  async updateExternalConfig(
    revisionId: number,
    data: UpdateExternalConfigPayload
  ): Promise<ApiResponse<unknown>> {
    const response = await api.patch<ApiResponse<unknown>>(
      `/document-revisions/${revisionId}/external-config`,
      data
    );
    return response.data;
  }
}

export default new UpdateExternalConfigApi();
